export default "__VITE_ASSET__CwMhqS3F__"